module.exports = __webpack_public_path__ + "img/nature-2858213_1280-cut-HiRes.ec852be2.jpg";